import { MessageTemplate } from './MessageToolModal';

export const MESSAGE_MAX_CHARACTERS = 550;
export const CONTACT_INFO_MAX_CHARACTERS = 100;

export const MESSAGE_TEMPLATES = {
  PERFORMANCE_METRICS: `Hi {{managerName}},

We're exploring {{creatorName}} for a campaign and would love to understand their current performance. 

Could you please share {{creatorName}} audience demographics and most recent engagement metrics?

Thanks!`,

  BRAND_WORK: `Hi {{managerName}},

We are considering {{creatorName}} for a partnership with [Brand Name]. 

To help us with our decision, could you please share some examples of previous successful and relevant brand collaborations?

Looking forward to seeing them.`,

  CATEGORY_EXCLUSIVITY: `Hi {{managerName}},

We are exploring a potential partnership with {{creatorName}} for [Brand Name], in the [Brand Category] space.

Could you please let us know if they have any active partnerships with competing brands in this category?

Thank you for your time.`,

  AVAILABILITY_RATES: `Hi {{managerName}},

We're interested in partnering with {{creatorName}} for a campaign with [Brand Name].

Could you please let us know their availability over the coming weeks, along with their rate card?

Looking forward to discussing.`,
} as const;

export const TEMPLATE_METADATA: MessageTemplate[] = [
  {
    id: 'PERFORMANCE_METRICS',
    event_name: 'performance_metrics',
    title: 'Request performance metrics',
    icon: 'Stats',
  },
  {
    id: 'BRAND_WORK',
    event_name: 'brand_work',
    title: 'Request past brand work',
    icon: 'Mediapacks',
  },
  {
    id: 'CATEGORY_EXCLUSIVITY',
    event_name: 'category_exclusivity',
    title: 'Confirm category exclusivity',
    icon: 'Lock',
  },
  {
    id: 'AVAILABILITY_RATES',
    event_name: 'availability',
    title: 'Check availability and rates',
    icon: 'Calendar',
  },
] as const;

export const SIXTEENTH_MANAGER_IDS = [
  '4e76c67d-eb9f-4a09-9bdb-ba9e75b82e47', // Abigail Ladwig
  '221b0766-a332-4da2-9844-cd26dc54eaad', // Alexandra Saint
  'a2d62572-8a61-48b8-bfeb-4684f596da97', // Amy Thomas
  'f125dcd2-4733-4517-9301-68441594b186', // Ariel Myint
  '92f06752-6835-4c40-bea7-bf1adb52dc59', // Bella Lennartsson
  '245741a0-dcec-4d5e-92e9-3ca404bc3124', // Brendan Nahmias
  'c0d78a70-3a11-4baf-8c23-d378461bcde0', // Camille Buranday
  '15e79283-e23f-45cc-b20b-0113c57c7afc', // Dana.dellicarpini
  'a6b92344-17fb-4b9c-898d-aba0f1f09796', // Danny Lowney
  '72c4aa3f-d4ac-4be5-a099-64904b7e2f50', // Elysia
  'c6bdf27f-0805-4e24-956c-eea202e4ff49', // Emma Gittleman
  '3e431fb3-c19a-48dd-8bce-4d87ee8ab6c1', // Georgine Nwofor
  'd0feb255-d1cd-4e47-9904-bd994b7ecf01', // Hattie Sprittles
  '9143b8d1-9873-4fdb-9142-f5194d10050d', // Isabelle Denton
  '375f345d-d982-4ed1-ba18-0ea35c6a70bc', // Katelyn Vasconcelos
  'd1d7061c-e391-4b01-8227-97887768796c', // Kiera Perez
  '9e876bb5-8fd9-4919-8ed6-335dbd514ea9', // Lherlands
  '7b2f4a16-3076-451a-8023-2a1d706de8a7', // Lilla Muzsik
  'b0ebbfd0-3fdf-4645-803f-d821b10c18eb', // Lucy
  'f49c72c3-7301-4d94-b1fd-9f190a107c97', // Madeline Lacey
  '543fee4d-7ffb-475b-b5f5-7d53610ce669', // Mary Mashburn
  'd9fa9797-5cee-430b-bde5-bb30f93e023e', // Matt Snyder
  'c8811044-4e2a-47d0-8df3-d99071c57478', // Megan Frantz
  '37e94e3d-8336-4dda-95c7-457ee26327f2', // Myq Rodriguez
  '3d994d75-eba8-46d8-ad31-75dd335079c9', // Partnerships
  '1dfbc4ed-0e79-4fc1-a5ab-47cc5e523624', // Philip Battiato
  'b72380db-f8dc-4c12-b32b-afcdc91ddcfd', // Praaise
  '30152af7-74db-4a08-b658-73f5475b9a3e', // RJ Thorpe
  '3f84240c-83f3-4e73-9e3f-e4cb0716459a', // Regina Carvalho
  '0c3ccc14-5d60-470f-a9c3-0202a8502b69', // Rick Bhatia
  'ed271fec-7d94-4c81-ad17-67b3991854b8', // Skye Petrie
  '815152af-40ff-4ec3-9a31-47226d2a3fdb', // Steph Lechman
  '63f94283-56ef-4b6a-8858-09229fd4cae0', // Talia Phillips
  '20419139-eb23-49bf-9748-d8dec7fa79fd', // Tara Mulligan
  'b5b2e5ab-fb8e-4e6c-95bb-24bec34c3ae1', // Tate Pilch
  'a5a0babc-2b08-49b6-9a77-4db847eb45ce', // TimX
  'df5380fd-4e04-4cae-b1fe-3ad20273e81a', // Tom Caplan
  '8ea58ff7-e1bf-4970-9f6c-b31f7ade3ebd', // Victoria Bachan
  'ca016d8f-37f4-471e-ad5f-49bfe5b82874', // Will McGinn
  '94c918da-00f2-4278-83a0-b1e428b2589f', // Zsanett Korik
];

export const TESTING_MANAGER_IDS = [
  '992c7f6d-da60-43b5-aeea-2b038fbe1cc7', // Marina (dev)
  '9ccf3e29-aa15-4e75-97a0-75181e20e010', // Giaco (dev)
  '81aa47a0-8bba-4708-8e28-93917afb6e1b', // Dani (dev)
  'bc986fb8-a951-412e-b174-94e97dbeb1c5', // Oswaldo (dev)
  '124bd6f7-fe93-4145-b572-baa3b330859e', // Isaac (dev)
  '4c07e435-7edc-4cad-955a-e1b3ce4522cc', // Marina (prod)
  '26a21b2c-f585-4a50-be5b-300f57b63fbd', // Giaco (prod)
  'efb7b074-225f-40a7-a418-97b0b83abf69', // Dani (prod)
  '901335fc-ec1a-4306-92b7-02e3e770b9b5', // Oswaldo (prod)
  '472db605-6280-4952-af8f-45f178e684ec', // Jaak (prod)
];
